export const state = {
  importProductCount: null,
}

export const getters = {
  importProductCount: (state) => state.importProductCount,
}

export const mutations = {
  setImportProductCount(state, data) {
    state.importProductCount = data
  },
}

export const actions = {
  updateImportProductCount({ commit }, payload) {
    commit('setImportProductCount', payload)
  },
}
